module.exports = __webpack_public_path__ + "src/assets/sounds/water_pouring_sound.mp3";